export default __webpack_public_path__ + "static/media/avatar.1f5df016.svg";